module.exports = __webpack_public_path__ + "img/sand-decal-24.6fc3a715.png";